import Image from 'next/image'
import { useRouter } from 'next/router'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import buttonSrc from '@/assets/images/extension/cta-button.png'
import {
  SIDER_COLLAPSED_WIDTH,
  SIDER_EXPANDED_WIDTH,
} from '@/components/layout/irm/irm-layout'
import { SafeNewTabLink } from '@/components/safe-new-tab-link'
import { useIntl } from '@/i18n/hooks/use-intl'
import { ampli } from '@/utils/ampli'

const EXTENSION_ID = 'amjaoklkeffceamacmpblhhhfajdoihl'

interface CtaButtonProps {
  isCollapsed: boolean
  className?: string
}
const CtaButton: FunctionComponent<CtaButtonProps> = ({
  isCollapsed,
  className,
}) => {
  const router = useRouter()
  const { formatMessage } = useIntl()

  const handleClickCallToAction: VoidFunction = () => {
    ampli.visitChromeExtensionWebstore({
      path: router.asPath,
      from: 'banner',
    })
  }

  if (isCollapsed) {
    return (
      <CtaWrapper className={className} isCollapsed={isCollapsed}>
        <CollapsedWrapper>
          <Image
            alt='chrome extension'
            height={32}
            src={buttonSrc}
            width={39}
          />
        </CollapsedWrapper>
      </CtaWrapper>
    )
  }

  return (
    <CtaWrapper className={className} isCollapsed={isCollapsed}>
      <BorderWrapper>
        <SafeNewTabLink
          href={`https://chromewebstore.google.com/detail/${EXTENSION_ID}`}
          onClick={handleClickCallToAction}
        >
          <Wrapper>
            <Image
              alt='chrome extension'
              height={32}
              src={buttonSrc}
              width={39}
            />
            {!isCollapsed && (
              <Wording>
                {formatMessage({
                  id: 'general:sidebar_extension_cal_to_action',
                })}
              </Wording>
            )}
          </Wrapper>
        </SafeNewTabLink>
      </BorderWrapper>
    </CtaWrapper>
  )
}

export default styled(CtaButton)``

const Wording = styled.span`
  color: ${({ theme }): string => theme.colors.text.secondary};
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
`

const Wrapper = styled.div`
  padding: 9px 6px;
  background: linear-gradient(
    97deg,
    #f7f7f7 32.82%,
    ${({ theme }): string => theme.colors.base.grey.grey6} 78.92%
  );
  border-radius: 4px;
  box-shadow: 0 2px 3.5px 0 rgba(255, 255, 255, 0.8) inset;
  display: flex;
  align-items: center;
  white-space: pre-line;
  gap: 9px;
`

const BorderWrapper = styled.div`
  width: 100%;
  max-width: 170px;
  border-radius: 5px;
  background: linear-gradient(180deg, #f4f4f4 32.82%, #dbdbdb 78.92%);
  padding: 1px;
`

const CtaWrapper = styled.div<{ isCollapsed: boolean }>`
  max-width: ${(props): number =>
    props.isCollapsed ? SIDER_COLLAPSED_WIDTH : SIDER_EXPANDED_WIDTH}px;
  transition: max-width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CollapsedWrapper = styled.div`
  display: flex;
  justify-content: center;
`
